/**
 * Punto de color de una red social (Facebook, Instagram…) para chips, tablas y leyendas.
 */
import React from 'react';
import { ink } from '../admin/studioUi';
import { NETWORK_COLORS } from './socialRepoUtils';

export default function NetworkDot({ red, size = 8 }) {
    return (
        <span
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: NETWORK_COLORS[red] || ink.faint,
                display: 'inline-block',
                flexShrink: 0,
            }}
        />
    );
}
